<template>
  <div>
    <template>
      <v-menu open-on-hover offset-y @click.native.stop.prevent key="send_Invoice_chat">
        <template v-slot:activator="{ on }">
          <v-btn
            outline
            :loading="loading"
            :disabled="loading"
            small
            fab
            color="primary"
            v-on="on"
            v-tooltip.top="$t('send_receipt_tax_chat')"
            >
            <span class="fa fa-send"></span>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile key="receipt" @click="$emit('sendInvoicePDF',{type:'receipt',order})">
            <v-list-tile-title>{{ $t('send_receipt_chat') }}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile key="invoice" @click="$emit('sendInvoicePDF',{type:'invoice',order})">
            <v-list-tile-title>{{ $t('send_taxinvoice_chat') }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </template>
  </div>
</template>

<script>
export default { props:['order', 'loading']}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/SendInvoiceBTN.vue